import React from 'react'
import { func, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useAtSize, Separator } from '@fs/zion-ui'
import leftChevron from '../../../../images/leftChevron.svg'
import rightChevron from '../../../../images/rightChevron.svg'

const centeredContentStyle = css`
  display: flex;
  height: auto;
  align-items: center;
  justify-content: center;
`

const templeTitleStyle = css`
  color: #88ddf8;
  font-family: museo, Verdana;
  font-size: clamp(1.1rem, 1.2vw, 1.5rem);
  margin: 10px 0;
`

const dedicationStyle = css`
  padding-bottom: 20px;
  font-size: clamp(0.9rem, 0.8vw, 1rem);
`

export default function TempleInfo({ info, moveLeft, moveRight, numTemples }) {
  const atSize = useAtSize()

  const templeImageStyle = css`
    max-width: 90%;
  `

  const arrowBtnStyle = css`
    border: none;
    border-radius: 50%;
    ${atSize({ default: 'width: 25px; height: 25px', md: 'width: 50px; height: 50px' })};
    &:hover {
      cursor: pointer;
    }
    img {
      vertical-align: middle;
    }
  `

  return info && info.length !== 0 ? (
    <>
      <div css={centeredContentStyle}>
        {numTemples > 1 && (
          <button css={arrowBtnStyle} onClick={() => moveLeft()} type="button" onKeyPress={() => moveLeft()}>
            <img className="leftArrow" src={leftChevron} alt="Left Arrow" />
          </button>
        )}
        <img css={templeImageStyle} src={info.imageUrl} alt="Temple" />
        {numTemples > 1 && (
          <button css={arrowBtnStyle} onClick={() => moveRight()} type="button" onKeyPress={() => moveRight()}>
            <img className="rightArrow" src={rightChevron} alt="Right Arrow" />
          </button>
        )}
      </div>
      <div css={templeTitleStyle}>{info.textTitle}</div>
      <Separator size="sm" />
      <div css={dedicationStyle}>{info.textAdditional}</div>
    </>
  ) : null
}

TempleInfo.propTypes = {
  info: shape({
    category: string,
    categoryId: number,
    endYear: number,
    icon: string,
    id: number,
    imageUrl: string,
    languageOnly: string,
    localeOnly: string,
    startYear: number,
    subcategory: string,
    textAdditional: string,
    textHeadline: string,
    textTitle: string,
    tileType: string,
    year: number,
  }),
  moveLeft: func,
  moveRight: func,
}
